import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"margin-left":"auto"} }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { style: {"color":"#6c757d"} }
const _hoisted_4 = { class: "version" }
const _hoisted_5 = { style: {"display":"flex","justify-content":"center","padding":"1rem"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"center","padding":"1rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonHeader = _resolveComponent("CommonHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MobileNav = _resolveComponent("MobileNav")!
  const _component_LoginDialog = _resolveComponent("LoginDialog")!
  const _component_LogoutDialog = _resolveComponent("LogoutDialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_AlertDialog = _resolveComponent("AlertDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CommonHeader, { ref: "commonHeader" }, null, 512),
    _createVNode(_TransitionGroup, { name: "tran-nortification" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nortification.list, (nortice) => {
          return (_openBlock(), _createElementBlock("div", {
            key: nortice.message,
            class: _normalizeClass(['header-nortification-' + nortice.type, "header-nortification"])
          }, [
            _createElementVNode("span", _hoisted_1, _toDisplayString(nortice.message), 1),
            _createElementVNode("span", {
              style: {"margin-left":"auto","font-size":"xx-large","padding":"0 10px","cursor":"pointer","line-height":"0"},
              onClick: ($event: any) => (_ctx.nortification.clear(nortice.identifer))
            }, " × ", 8, _hoisted_2)
          ], 2))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("main", {
      class: "main-contents",
      style: _normalizeStyle({'min-height':_ctx.mainAreaMinHeight})
    }, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_ctx.isHomeURL)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  key: _ctx.$route.fullPath
                }))
              : _createCommentVNode("", true)
          ], 1024)),
          (!_ctx.isHomeURL)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 4),
    _createVNode(_component_MobileNav),
    (_ctx.isFooterVisible)
      ? (_openBlock(), _createElementBlock("footer", {
          key: 0,
          style: _normalizeStyle({height:_ctx.footerHeight + 'px'})
        }, [
          _createElementVNode("span", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode(" Copyright © 2022-2025 forkstyle All Rights Reserved. ")),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.displayVersion), 1)
          ])
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.isDebug)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent('DebugFooter'), { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_LoginDialog, { ref: "loginDialog" }, null, 512),
    _createVNode(_component_LogoutDialog, { ref: "logoutDialog" }, null, 512),
    _createVNode(_component_ConfirmDialog, {
      ref: "confirmDialogRef",
      yesButton: _ctx.confirmYesText
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.confirmText), 1)
        ])
      ]),
      _: 1
    }, 8, ["yesButton"]),
    _createVNode(_component_AlertDialog, { ref: "alertDialogRef" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_ctx.alertText), 1)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}